var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

var _interopRequireWildcard = require("@babel/runtime/helpers/interopRequireWildcard");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _extends2 = _interopRequireDefault(require("@babel/runtime/helpers/extends"));

var _objectWithoutProperties2 = _interopRequireDefault(require("@babel/runtime/helpers/objectWithoutProperties"));

var _react = _interopRequireWildcard(require("react"));

var _Basic = require("../../../elements/Basic");

var _MatchComponents = require("./MatchComponents");

var _jsxFileName = "/builds/sport1/libraries/universal-components/lib/components/Universal/Match/AssociatedMatchWithScores.js";

var AssociatedMatchWithScores = function AssociatedMatchWithScores(_ref) {
  var borderX = _ref.borderX,
      mb = _ref.mb,
      textColor = _ref.textColor,
      displayText = _ref.displayText,
      homeTeam = _ref.homeTeam,
      homeTeamName = _ref.homeTeamName,
      awayTeam = _ref.awayTeam,
      awayTeamName = _ref.awayTeamName,
      homeScore = _ref.homeScore,
      awayScore = _ref.awayScore,
      rest = (0, _objectWithoutProperties2.default)(_ref, ["borderX", "mb", "textColor", "displayText", "homeTeam", "homeTeamName", "awayTeam", "awayTeamName", "homeScore", "awayScore"]);
  return _react.default.createElement(_Basic.Row, (0, _extends2.default)({
    borderX: borderX,
    borderColor: "border.main",
    mb: mb
  }, rest, {
    __source: {
      fileName: _jsxFileName,
      lineNumber: 18,
      columnNumber: 5
    }
  }), _react.default.createElement(_Basic.Row, {
    flexing: true,
    minWidth: 0,
    __source: {
      fileName: _jsxFileName,
      lineNumber: 19,
      columnNumber: 9
    }
  }, _react.default.createElement(_MatchComponents.TeamName, {
    color: textColor,
    size: "small",
    pr: 0,
    __source: {
      fileName: _jsxFileName,
      lineNumber: 20,
      columnNumber: 13
    }
  }, displayText), _react.default.createElement(_MatchComponents.TeamName, {
    color: textColor,
    size: "small",
    alignRight: true,
    __source: {
      fileName: _jsxFileName,
      lineNumber: 23,
      columnNumber: 13
    }
  }, homeTeamName || homeTeam.shortName || homeTeam.name)), _react.default.createElement(_MatchComponents.MatchScore, (0, _extends2.default)({
    color: textColor,
    size: "small",
    p: 2,
    style: {
      whiteSpace: 'nowrap'
    }
  }, {
    homeScore: homeScore,
    awayScore: awayScore
  }, {
    __source: {
      fileName: _jsxFileName,
      lineNumber: 27,
      columnNumber: 9
    }
  })), _react.default.createElement(_Basic.View, {
    flexing: true,
    minWidth: 0,
    __source: {
      fileName: _jsxFileName,
      lineNumber: 34,
      columnNumber: 9
    }
  }, _react.default.createElement(_MatchComponents.TeamName, {
    color: textColor,
    size: "small",
    textAlign: "left",
    __source: {
      fileName: _jsxFileName,
      lineNumber: 35,
      columnNumber: 13
    }
  }, awayTeamName || awayTeam.shortName || awayTeam.name)));
};

var _default = (0, _react.memo)(AssociatedMatchWithScores);

exports.default = _default;